/* eslint-disable no-extra-boolean-cast */
import { get } from "lodash";
import moment from "moment";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as patientActions from "~/store/patient/patientAction";
import {
  apiRequestMedproPatientList,
  apiRequestMedproSuggestionPatientList,
  getByUserId,
  insertPatient
} from "~/store/patient/patientApi";
import TYPES from "~/store/patient/patientType";
import * as patientFormTypes from "~/store/patientForm/patientFormType";
import * as totalDataActions from "~/store/totalData/actions";
import { USER_SESSSION_EXPIRED } from "~/store/user/userType";
import { huyi } from "~/utils/clog";
import { CHECK_WITH_INSURANCE_CODE_EXIST } from "~/utils/constants";
import { routerByPartnerId } from "~/utils/func";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";

// chọn bệnh nhân tái khám để auto fill thông tin vào form bhyt
function* requestSelectPatientReExam() {
  try {
    const { patientExam } = yield select(state => state.followUpExam);
    // console.log(patientExam);
    yield put({
      type: TYPES.SELECT_PATIENT_REEXAM_SUCCESS,
      payload: patientExam
    });
  } catch (error) {
    console.log(error);
  }
}

function* getPatientByMSBNWorker({ data }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    yield put({ type: TYPES.SHOW_LOADING });
    const partnerid = yield select(state => state.totalData.partnerId);
    const patientNumber = yield select(state => state.patient.patientNumber);
    // const postData = { ...data };
    const postData = data !== null ? { ...data } : { msbn: patientNumber };
    delete postData.callback;
    const token = yield select(state => state.user.info.token);
    const response = yield client.findByMsbn(postData, {
      partnerid: partnerid === "" ? AppId : partnerid,
      appid: AppId,
      token,
      platform
    });
    yield put({
      type: TYPES.GET_PATIENT_BY_MSBN_SUCCESS,
      patient: response.data
    });
    yield put({ type: TYPES.HIDE_LOADING });
    history.push("/xac-thuc-dien-thoai-benh-nhan");
    // if (data.callback && typeof data.callback === "function") {
    //   data.callback();
    // }
  } catch (error) {
    const message = get(error, "response.data.message");
    openToast(message, "error");
    // yield put({
    //   type: TYPES.GET_PATIENT_BY_MSBN_FAILURE,
    //   errorMessage: error.response.data.message
    // });
    yield put({ type: TYPES.HIDE_LOADING });
  }
}

function* getPatientByUserIdWorker({ data }) {
  try {
    let baseUrl;
    if (!data.base_url) baseUrl = yield select(state => getBaseUrl());
    else baseUrl = data.base_url;

    const response = yield call(getByUserId, baseUrl, data);
    if (typeof response.data.error_code === typeof undefined) {
      yield put({
        type: TYPES.GET_PATIENT_BY_USERID_SUCCESS,
        patientList: response.data
      });
    } else {
      if (response.data.error_code === -2) {
        yield put({
          type: TYPES.SHOW_ALERT_INFO_CHOOSE_PATIENT,
          errorMessage: response.data.error_message
        });
        yield put({
          type: TYPES.CLEAR_STATE
        });
      }
    }
  } catch (error) {
    yield put({ type: TYPES.GET_PATIENT_BY_USERID_FAILURE, error });
  }
}

function* insertPatientWorker({ data, callback }) {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const response = yield call(insertPatient, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    yield put({
      type: TYPES.INSERT_PATIENT_SUCCESS,
      supporterList: response.data
    });
    callback();
  } catch (error) {
    yield put({
      type: TYPES.INSERT_PATIENT_FAILURE,
      errorMessage: error.errorMessage
    });
  }
}

function* deletePatientWorker({ deletePatientCallback }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const { selectedPatient } = yield select(state => state.patient);
    const token = yield select(state => state.user.info.token);
    yield client.unlinkPatient({ id: selectedPatient.id }, { token, platform });

    openToast("Bạn đã xóa hồ sơ bệnh nhân thành công!");
    put({
      type: TYPES.DELETE_PATIENT_SUCCESS
    });
    yield put({ type: TYPES.UMC_CHOOSE_PATIENT_LIST_REQUEST });
    deletePatientCallback();
  } catch (error) {
    deletePatientCallback();
    openToast(error.message, "error");
    yield put({
      type: TYPES.DELETE_PATIENT_FAILURE,
      errorMessage: error.errorMessage
    });
  }
}

function* searchPatientByInfoWorker() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const searchPatientInfo = yield select(
      state => state.patient.formSearchPatientByInfo
    );

    const keys = Object.keys(searchPatientInfo);
    const postData = {};
    keys.map(key => {
      postData[key] = searchPatientInfo[key].value;
      return "";
    });
    const partnerid = yield select(state => state.totalData.partnerId);
    yield put({ type: TYPES.SHOW_LOADING });
    const token = yield select(state => state.user.info.token);
    const response = yield client.findByExtraInfo(postData, {
      partnerid: partnerid === "" ? AppId : partnerid,
      token,
      platform
    });
    const responseData = response.data;
    const isValidData = Array.isArray(responseData);
    yield put({
      type: TYPES.SEARCH_PATIENT_BY_INFO_REQUEST_SUCCESS,
      searchPatientByInfoList: isValidData ? responseData : []
    });
    yield put({ type: TYPES.HIDE_LOADING });
    history.push("/ket-qua-tim-benh-nhan");
  } catch (error) {
    const message = get(error, "response.data.message");
    openToast(message, "error");
    yield put({
      type: TYPES.SEARCH_PATIENT_BY_INFO_REQUEST_FAILURE,
      errorMessage: error.errorMessage
    });
    yield put({ type: TYPES.HIDE_LOADING });
  }
}

function* requestChoosePatientList() {
  try {
    const t = yield select(state => state.totalData);
    const u = yield select(state => state.user);
    const p = yield select(state => state.patient);

    let postData;
    if (window.location.pathname.includes("chon-ho-so")) {
      postData = {
        serviceId: t.service?.id,
        roomId: t.room?.id,
        treeId: t.treeId,
        subjectId: t.subject?.id,
        doctorId: t.doctor?.id,
        bookingDate: t.days.date ? moment(t.days.date).toISOString() : ""
      };
    } else {
      postData = {};
    }

    const response = yield client.getValidPatientsByUserIdV2(postData, {
      token: u.info?.token,
      partnerid: t.partnerId
    });

    const { data } = response;
    if (typeof data.error_code === typeof undefined) {
      yield put({
        type: TYPES.UMC_CHOOSE_PATIENT_LIST_REQUEST_SUCCESS,
        data
      });

      yield p.selectedPatientId &&
        put(
          patientActions.selectPatientFromList(p.selectedPatientId, t.partnerId)
        );
    } else {
      if (data.error_code === -2) {
        yield put({
          type: TYPES.SHOW_ALERT_INFO_CHOOSE_PATIENT,
          alertMsg: data.error_message
        });
        yield put({
          type: USER_SESSSION_EXPIRED
        });
      }
    }
  } catch (error) {
    huyi({
      name: "client.getValidPatientsByUserIdV2",
      child: error,
      type: 0
    });
    // if (error.response.data.statusCode === 401) {
    //   yield put(logOutWithoutNoti());
    //   handleUnAuthorize();
    //   // yield put(loginActions.redirectToMedproId());
    // }
    yield put({
      type: TYPES.UMC_CHOOSE_PATIENT_LIST_REQUEST_FAIL,
      error
    });
  }
}

function* requestMedproPatientList() {
  try {
    const { info } = yield select(state => state.user);
    const response = yield call(apiRequestMedproPatientList, info);
    const { data } = response;
    if (typeof data.error_code === typeof undefined) {
      yield put({
        type: TYPES.GET_MEDPRO_PATIENT_LIST_SUCCESS,
        data
      });
    } else {
      if (data.error_code === -2) {
        yield put({
          type: TYPES.SHOW_ALERT_INFO_CHOOSE_PATIENT,
          alertMsg: data.error_message
        });
        yield put({
          type: USER_SESSSION_EXPIRED
        });
      }
    }
  } catch (error) {
    yield put({
      type: TYPES.GET_MEDPRO_PATIENT_LIST_FAIL,
      error
    });
  }
}

function* requestMedproPatientSuggestionList() {
  try {
    const { info } = yield select(state => state.user);
    const hospitalID = yield select(
      state => state.hospital.selectedHospital.id
    );
    const response = yield call(apiRequestMedproSuggestionPatientList, {
      ...info,
      hospital_id: hospitalID
    });
    const { data } = response;
    if (typeof data.error_code === typeof undefined) {
      yield put({
        type: TYPES.GET_MEDPRO_PATIENT_SUGGESTION_LIST_SUCCESS,
        data
      });
    } else {
      if (data.error_code === -2) {
        yield put({
          type: TYPES.SHOW_ALERT_INFO_CHOOSE_PATIENT,
          alertMsg: data.error_message
        });
        yield put({
          type: USER_SESSSION_EXPIRED
        });
      }
    }
  } catch (error) {
    yield put({
      type: TYPES.GET_MEDPRO_PATIENT_SUGGESTION_LIST_FAIL,
      error
    });
  }
}

function* requestCheckInsurance({ callback, text }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const { formCheckInsurance, selectedPatient } = yield select(
      state => state.patient
    );
    const totalDataReducer = yield select(state => state.totalData);
    const partnerid = get(totalDataReducer, "partnerId");
    const bookingInfo = get(totalDataReducer, "schedulesSelected")[0];
    const bookingDate = moment(bookingInfo.date).format("YYYY-MM-DD");

    let insuranceCode = get(formCheckInsurance, "code.value");
    insuranceCode = insuranceCode.toUpperCase();

    // const { fullName } = getInfoPatient(selectedPatient);
    const insuranceId =
      text === CHECK_WITH_INSURANCE_CODE_EXIST
        ? selectedPatient.insuranceCode
        : insuranceCode;
    const fullName = get(formCheckInsurance, "fullName.value");
    const birthday = get(formCheckInsurance, "birthday.value");
    const birthdayFormat = moment(birthday, "DD/MM/YYYY").format("YYYY-MM-DD");

    const postData = {
      // fullName: "Đoàn Thị Phụng",
      // insuranceId: "BT2797931297813",
      // birthday: "1938-07-10",
      fullName,
      insuranceId,
      birthday: birthdayFormat,
      bookingDate,
      patientId: selectedPatient.id
    };

    const response = yield client.getInsuranceDate(postData, {
      appid: AppId,
      partnerid,
      platform
    });
    const { data } = response;
    const isValid = get(data, "isValid");
    console.log(isValid);
    // const message = get(data, "message", "");
    if (!isValid) {
      // trường hợp trái tuyến
      // openToast(message, "error");
      let route;
      if (partnerid === "leloi") {
        route = routerByPartnerId(
          "/huong-dan-bao-hiem-y-te-trai-tuyen",
          partnerid
        );
        yield put(totalDataActions.setInsuranceChoice("TAI_KHAM"));
      } else {
        route = routerByPartnerId("/xac-nhan-thong-tin", partnerid);
      }
      yield put({
        type: TYPES.SELECT_PATIENT_FROM_DATA,
        payload: data
      });
      history.push(route);
    } else {
      // trường hợp đúng tuyến
      yield put(totalDataActions.setInsuranceChoice("DUNG_TUYEN"));
      const isExpiredInsurance = get(data, "expired", false);
      const message = get(data, "message", "");
      if (!!message) openToast(message, "error");
      if (!isExpiredInsurance) {
        if (data)
          yield put({
            type: TYPES.SELECT_PATIENT_FROM_DATA,
            payload: data
          });
        callback();
      } else {
        yield put({
          type: TYPES.CHECK_INSURANCE_OF_PATIENT_FAILED
        });
      }
    }
  } catch (error) {
    console.log(error);
    const message = get(error, "response.data.message");
    if (text !== CHECK_WITH_INSURANCE_CODE_EXIST) {
      openToast(message, "error");
    }
    yield put({
      type: TYPES.CHECK_INSURANCE_OF_PATIENT_FAILED
    });
  }
}

function* requestVerifyPhonePatient() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const currentRouter = get(history, "location.pathname");
    const partnerid = yield select(state => state.totalData.partnerId);
    const { selectedPatient, phoneNumberVerify } = yield select(
      state => state.patient
    );

    const postData = {
      phone: phoneNumberVerify,
      patientId: selectedPatient.id,
      msbn: selectedPatient.patientCode
    };
    const response = yield client.verifyPhone(postData, {
      partnerid,
      platform
    });
    if (currentRouter === "/cap-nhat-thong-tin") {
      yield put({
        type: patientFormTypes.UPDATE_PATIENT_FORM_REQUEST
      });
    } else {
      history.push("/xac-nhan-thong-tin-benh-nhan");
    }
    yield put(patientActions.verifyPhonePatientSuccess(response.data));
  } catch (error) {
    console.log(error);
    yield put(patientActions.verifyPhonePatientFailure(error.response.data));
    openToast(error.response.data.message, "error");
  }
}

function* requestVerifyInfoPatient() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const user = yield select(state => state.user);
    const partnerid = yield select(state => state.totalData.partnerId);
    const { secretKey } = yield select(state => state.patient);
    const postData = {
      secretKey: secretKey
    };
    yield client.addPatientIntoUser(postData, {
      partnerid,
      token: user.info.token,
      platform
    });
    openToast("Thêm bệnh nhân thành công.");
  } catch (error) {
    huyi({ name: "client.addPatientIntoUser", child: error, type: "error" });
    openToast(error.response.data.message, "error");
  } finally {
    // const bookingTree = yield select(state => state.totalData.bookingTree);
    const { urlRedirectAfterCreatePatient } = yield select(
      state => state.patientForm
    );
    setTimeout(() => {
      // if (bookingTree) {
      //   history.push("/chon-ho-so");
      // } else {
      //   history.push("/user");
      // }
      history.push(urlRedirectAfterCreatePatient);
    }, 1000);
  }
}

export default function* watcher() {
  yield all([
    takeLatest(TYPES.GET_PATIENT_BY_MSBN_REQUEST, getPatientByMSBNWorker),
    takeLatest(TYPES.GET_PATIENT_BY_USERID_REQUEST, getPatientByUserIdWorker),
    takeLatest(TYPES.INSERT_PATIENT_REQUEST, insertPatientWorker),
    takeLatest(TYPES.DELETE_PATIENT_REQUEST, deletePatientWorker),
    takeLatest(TYPES.SEARCH_PATIENT_BY_INFO_REQUEST, searchPatientByInfoWorker),
    takeLatest(TYPES.UMC_CHOOSE_PATIENT_LIST_REQUEST, requestChoosePatientList),
    takeLatest(TYPES.GET_MEDPRO_PATIENT_LIST, requestMedproPatientList),
    takeLatest(
      TYPES.GET_MEDPRO_PATIENT_SUGGESTION_LIST,
      requestMedproPatientSuggestionList
    ),
    takeLatest(TYPES.VERIFY_PHONE_PATIENT, requestVerifyPhonePatient),
    takeLatest(TYPES.VERIFY_INFO_PATIENT, requestVerifyInfoPatient),
    takeLatest(TYPES.CHECK_INSURANCE_OF_PATIENT, requestCheckInsurance),
    takeLatest(TYPES.SELECT_PATIENT_REEXAM, requestSelectPatientReExam)
  ]);
}
